import React from 'react';
import { ExclamationCircleFill } from 'react-bootstrap-icons';

import './components.css';

const EventTriggers = () => {
  return (
    <div className="event-triggers-container">
      <div className="event-triggers-title">Event triggers:</div>
      <div className="event-triggers-item">
        <ExclamationCircleFill size={10} color="#D05B5B" />
        Discrepancy in sertraline charting
      </div>
      <div className="event-triggers-item">
        <ExclamationCircleFill size={10} color="#D05B5B" />
        Change in apixaban dosage
      </div>
      <div className="event-triggers-item">
        <ExclamationCircleFill size={10} color="#D05B5B" />
        Cognitive impairment
      </div>
      <div className="event-triggers-item">
        <ExclamationCircleFill size={10} color="#D05B5B" />
        Crushed meds
      </div>
    </div>
  );
};

export default EventTriggers;
